import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '上游新闻“米宝宝街角”惜粮公益服务平台';
const baseUrl = '20231128GPXDPT';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./news/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsTwo',
      name: `${baseUrl}-newsTwo`,
      component: () => import('./news/NewsTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsThree',
      name: `${baseUrl}-newsThree`,
      component: () => import('./news/NewsThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsFour',
      name: `${baseUrl}-newsFour`,
      component: () => import('./news/NewsFour.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsFive',
      name: `${baseUrl}-newsFive`,
      component: () => import('./news/NewsFive.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'activity',
      name: `${baseUrl}-activity`,
      component: () => import('./pages/Activity.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'h5',
      name: `${baseUrl}-h5`,
      component: () => import('./pages/H5.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Register.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
